import { useState, useEffect } from 'react'
import axios, { AxiosResponse, AxiosError } from 'axios'

import Artist from './artist'

type Artist = {
  public_id: string
  display_name: string
  comment: string
  gift_detail: string
  icon_uri: string
  music_count: number
  market_music_count: number
  generative_count: number
}

function HomeArtists() {
  const [artists, setArtists] = useState<Artist[]>()

  useEffect(() => {
    fetchHomeArtists()
  }, [])

  const fetchHomeArtists = () => {
    axios({
      method: 'GET',
      url: `${import.meta.env.VITE_API_BASE_URI}/api/v1/home/artists`,
    })
      .then((response: AxiosResponse<{ artists: Artist[] }>) => {
        setArtists(response.data.artists)
      })
      .catch((error: AxiosError<{ error: string }>) => {
        console.error('error', error)
      })
  }

  return (
    <div className="artists">
      {artists && artists.length > 0 ? (
        artists.map((artist) => (
          <Artist key={artist.public_id} artist={artist} />
        ))
      ) : (
        <></>
      )}
    </div>
  )
}

export default HomeArtists
